export const calculateTotalDesignAssetsCost = (designAssetCosts: number[]) =>
  (designAssetCosts || []).reduce((acc: number, current: number) => acc + (current || 0), 0);
